// extracted by mini-css-extract-plugin
module.exports = {"async-root":"autosuggestInput_async-root__eeIwt","hideSuggestion":"autosuggestInput_hideSuggestion__CfyEA","autosuggestion-home":"autosuggestInput_autosuggestion-home__WC0KE"};